<template>
  <div>
    <section class="fluxo">
        <div class="container">
        <div class="row ">
          <div class="col-12 col-md-12 col-lg-9 mx-auto">
            <p>Empresas de Multicalculo, Insurtechs e Corretoras que possuem sistemas próprios e desejam oferecer aos seus clientes os produtos e serviços 
da Tokio Marine através da integração direta entre seus sistemas e o sistema da Tokio (APIs) para as modalidades de "Vendas" e "Gestão Carteira/Pós Venda". </p>
          </div>
        </div>
        <div class="row">
          <div class="col d-flex justify-content-center">
            <div class="menu mt-4 mb-4">
              <button :class="{ active: isActive[0] }" @click.prevent="toggleButton(0)">VENDAS</button>
              <button :class="{ active: isActive[1] }" @click.prevent="toggleButton(1)">GESTÃO CARTEIRA / PÓS VENDA</button>
            </div>    
          </div>
        </div>
        <div class="row">
          <div class="col">
            <component :is="currentComponent"></component>
          </div>
        </div>
      </div>
      </section>
  </div>
</template>

<script>
import Vendas from '@/views/fluxo/nova-integracao/Vendas.vue';
import Gestao from '@/views/fluxo/nova-integracao/Gestao.vue';

export default {
  data() {
    return {
      currentComponent: null,
      isActive: [true, false]
    };
  },
  
  mounted() {
    this.changeComponent(Vendas);
  },
  computed: {

  },
  methods: {

    async changeComponent(componentName) {
      try {
        switch (componentName) {
          case Vendas:
            this.currentComponent = Vendas;
            break;
            case Gestao:
            this.currentComponent = Gestao;
            break;
        }
      } catch (error) {
        console.error(`Erro ao carregar o componente '${componentName}':`, error);
      }
    },

    toggleButton(index) {
      this.isActive = this.isActive.map((_, i) => i === index);

      if (index === 0) {
        this.changeComponent(Vendas)
      } else{
        this.changeComponent(Gestao)
      }
    }
  }
};
</script>
